const SectionHeading = ({ iconSrc, title, subheading, style }) => (
  <div className='flexCentered' style={style}>
    <img
      src={iconSrc}
      className='icon'
      alt=""
    />

    <div className='title'>
      { title }
    </div>

    { subheading && (
      <div className='subheading'>
        { subheading }
      </div>
    )}

    <style jsx>
      {`
        .icon {
          height: 30px;
          width: 30px;
          margin-bottom: 1em;
        }
        
        .title {
          font-weight: 800;
          font-size: 1.2rem;
        }
        
        .subheading {
          font-weight: 600;
          font-size: 1.1rem;
        }
      `}
    </style>
  </div>
);

export default SectionHeading;